<template>
  <div class="permission ba-min-h-screen ba-overflow-hidden">
    <header
      v-if="false"
      class="ba-relative ba-overflow-hidden ba-w-full ba-h-full ba-pt-4 md:ba-pt-20"
    >
      <div class="ba-w-48 md:ba-w-auto ba-text-center ba-mx-auto">
        <a href="/" class="ba-inline-block">
          <img src="/img/logo.svg" />
        </a>
      </div>
      <img src="/img/figure1.svg" class="ba-hidden lg:ba-block ba-absolute ba-left-1/12 ba-top-1/5" />
      <img
        src="/img/figure2.svg"
        class="ba-hidden lg:ba-block ba-absolute ba--right-1/12 2xl:ba--right-1/12 ba-bottom-1/12"
      />
    </header>
    <transition appear name="fade">
      <main
        class="ba-fixed ba-inset-x-0 ba-bottom-0 ba-z-50 ba-flex ba-p-2 ba-overflow-hidden ba-top-0"
      >
        <slot />
        <img
          v-if="false"
          src="/img/figure3.svg"
          class="ba-hidden lg:ba-block ba-absolute ba-bottom-1/6 ba-left-1/12"
        />
        <img
          v-if="false"
          src="/img/figure4.svg"
          class="ba-hidden lg:ba-block ba-absolute ba--bottom-1/6 ba-right-1/5"
        />
      </main>
    </transition>
  </div>
</template>

<script>
export default {
  name: "vis-inner-layout"
};
</script>
